<script setup lang="ts">
import { Icon as IconifyIcon } from "@iconify/vue";

interface Props {
  icon: string;
  class?: string;
  width?: string | number;
  height?: string | number;
}

const props = withDefaults(defineProps<Props>(), {
  class: "",
  width: 24,
  height: 24
});
</script>

<template>
  <IconifyIcon
    :icon="props.icon"
    :class="props.class"
    :width="props.width"
    :height="props.height"
  />
</template>
